import { render, staticRenderFns } from "./PlatformWhiteListForm.vue?vue&type=template&id=faf52e24&"
import script from "./PlatformWhiteListForm.vue?vue&type=script&lang=js&"
export * from "./PlatformWhiteListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports